import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import get from 'lodash/get';
import { getTimestampDate } from 'dashboard/reducers/announcements/utils';

const DRAFT = 'DRAFT';
const CONTEXT = 'cms';

const widgetsFields2Object = (response) =>
  response.entries.map((entry) => {
    const fields = appHelpers.getFieldsFromEntry(entry);
    return {
      ...entry,
      fields,
    };
  });

const getAnnouncementsUrl = (showOnlyPublishedWidgets) => {
  if (showOnlyPublishedWidgets) return DepsService.rest.cms.announcements.first.url;
  return DepsService.rest.cms.announcements.second.url;
};

export const fetchAnnouncements = async (showOnlyPublishedWidgets, jurisdictionId) => {
  const url = getAnnouncementsUrl(showOnlyPublishedWidgets);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  const response = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
  const result = {
    draft: response.versionType === DRAFT,
    items: widgetsFields2Object(response),
  };
  return result;
};

export const discardChanges = async (jurisdictionId) => {
  const { url } = DepsService.rest.cms.announcements.discard;
  const queryParams = {};
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const downloadAttachment = async (jurisdictionId, attachment) => {
  const { url } = DepsService.rest.cms.widgets.download;
  const queryParams = {};
  const urlParams = {
    jurisdictionId,
    contentId: attachment.id,
  };

  if (attachment.fileSource) {
    const b64Data = attachment.fileSource.split(',');
    const blob = appHelpers.b64toBlob(b64Data[1], attachment.fileType);
    return window.saveAs(blob, attachment.name);
  }
  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams).promise.then((result) => {
    const blob = new Blob([result.data], {});
    window.saveAs(blob, attachment.name);
  });
};

const transformAnnouncements = (newAnnouncements, locales) =>
  newAnnouncements.reduce((announcements, announcement) => {
    const data = {
      fields: appHelpers.setFieldsToEntry(announcement.fields),
      title: 'announcements',
    };
    if (announcement.publishFrom) {
      data.publishFrom = getTimestampDate(announcement.publishFrom);
    }
    if (announcement.publishTo) {
      data.publishTo = getTimestampDate(announcement.publishTo);
    }
    if (announcement.attachments) {
      data.attachments = announcement.attachments;
      locales.map((locale) => {
        const attachment = get(announcement.attachments, `${locale.code}[0]`);
        if (attachment && !attachment.id) {
          data.attachments[locale.code] = [
            {
              name: attachment.name,
              content: attachment.fileSource.split(',')[1],
            },
          ];
        }
        if (!attachment) {
          data.attachments[locale.code] = undefined;
        }
      });
    }
    return announcements.concat(data);
  }, []);

export const updateAnnouncements = async (newAnnouncements, modified, locales, secondHandApproval, jurisdictionId) => {
  const url = getAnnouncementsUrl(!secondHandApproval);
  const entries = transformAnnouncements(newAnnouncements, locales);
  const queryParams = { entries, modified };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/announcements.api.js